import {useCallback, useState} from 'react';
import {Balance} from '@modules/balance/core/domain/BalanceRepository';
import {ApiBalanceRepository} from '@modules/balance/core/infrastructure/repositories/ApiBalanceRepository';

export interface UseBalanceResult {
  balance: number;
  checkBalance: () => Promise<void>;
}

export const useBalance = (): UseBalanceResult => {
  const [balance, setBalance] = useState<Balance>();

  const checkBalance = useCallback(async () => {
    const newBalance = await ApiBalanceRepository.getBalance();
    setBalance(newBalance);
  }, []);

  const formattedBalance = balance?.amount ? balance.amount / 100 : 0;

  return {balance: formattedBalance, checkBalance};
};
